import config from "config";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";

import { isInIFrame } from "services/iframe";
import { oktaAuth } from "services/okta";

import { RootContentWithContext } from "./RootContentWithContext";

const Root = () => {
  const { isIframed } = config.get();

  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(
      toRelativeUrl(originalUri || "", window.location.origin)
    );
  };

  // Disallow embedding, unless the app's config has isIframed = true
  if (isInIFrame() && !isIframed) {
    return (
      <div className="text-center">
        iFrame is unsupported. For more information, contact{" "}
        {config.SUPPORT_EMAIL}
      </div>
    );
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <RootContentWithContext />
    </Security>
  );
};

export default Root;
